import { getPocFields, POCFieldAttribute } from 'modules/settings/pods/settings-integrations/service';
import { useEffect, useState } from 'react';
import { newIdentityProviderMapping } from '../service/active-directory.business';
import { ActiveDirectoryMapping } from '../components';

export interface UseActiveDirectoryMappingsProps {
    activeDirectoryMappings?: ActiveDirectoryMapping[];
    onMappingsReady: (mappings: ActiveDirectoryMapping[]) => void;
}

const getMappingsFromDataPoints = (
    mappings: ActiveDirectoryMapping[],
    pocFieldsResult: POCFieldAttribute[]
): ActiveDirectoryMapping[] => {
    const mandatoryFields = pocFieldsResult.filter((pf) => pf.mandatory);

    if (!mappings.length) {
        return mandatoryFields.map((pf, index) => newIdentityProviderMapping(index, pf.attribute));
    }

    const missingMandatory = mandatoryFields.filter((pf) => !mappings.some((m) => m.operatorField === pf.attribute));

    if (!missingMandatory.length) {
        return mappings;
    }

    const maxIndex = Math.max(0, ...mappings.map((m) => m.index));
    const newMappings = missingMandatory.map((pf, i) => newIdentityProviderMapping(maxIndex + 1 + i, pf.attribute));
    return [...mappings, ...newMappings];
};

export const useActiveDirectoryMappings = ({
    activeDirectoryMappings,
    onMappingsReady,
}: UseActiveDirectoryMappingsProps) => {
    const [pocFields, setPocFields] = useState<POCFieldAttribute[]>([]);

    useEffect(() => {
        getPocFields().then((pocFieldsResult) => {
            setPocFields(pocFieldsResult);
        });
    }, []);

    useEffect(() => {
        onMappingsReady(getMappingsFromDataPoints(activeDirectoryMappings || [], pocFields));
    }, [activeDirectoryMappings, pocFields, onMappingsReady]);

    return { pocFields };
};
